<template>
  <BaseText
    v-bind="$attrs"
    v-on="$listeners"
    :href="href"
    :openInCurrentTab="false"
    :styleConfig="styleConfig"
  >
    <slot>
      {{ firstName }} {{ lastName }}
    </slot>
  </BaseText>
</template>

<script>
  import BaseText from '@base/v2/base-text'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  const path = require('path');

  export default {
    name: 'LinkNamePrimary',
    inheritAttrs: false,
    components: {
      BaseText,
    },
    props: {
      tenantUser: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            width: 'fit-content',
          },
          text: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: {
              '': FontStyle.weight.lg,
              selected: FontStyle.weight.xl,
            },
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.text,
        {
          color: {
            '': this.color.dark2(),
            hover: this.color.action1(),
            active: this.color.action1(),
            disabled: this.color.dark3(),
          },
          textDecoration: {
            '': 'none',
            hover: `solid underline ${this.color.action1()} 1px`,
            active: `solid underline ${this.color.action1()} 1px`,
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      firstName: function () {
        return this.tenantUser?.user?.firstName;
      },
      lastName: function () {
        return this.tenantUser?.user?.lastName;
      },
      href: function () {
        const tenantUserId = this.tenantUser?.id?.toString();
        if (tenantUserId == null) {
          return null;
        }
        return `${path.join(process.env.BASE_URL, 'users', tenantUserId)}`;
      },
    },
  };
</script>
